<template lang="pug">
  .ui-files(v-if="files && files.items.length")
    b-modal(:active.sync="modalActive")
      img(:src="modalImage")
    a.media.pt-5.mt-5(v-if="files" v-for="file in files.items" :key="file.id" :href="file.download_url" @click="click($event, file)")
      .media-left
        //figure.image: img(:src="file.path" width="400")
        .image
          ui-file-preview(:file="file" size="is-large" preview)
      .media-content
        p: strong {{ file.name }}
        p.has-text-grey Добавлено: {{ file.created_at | dateFormat }}
</template>

<script>
export default {
  name: 'ui-files',
  props: {
    files: [Object, Array],
  },
  data: () => ({
    modalActive: false,
    modalImage: '',
  }),
  methods: {
    click(event, file) {
      if (file.isImage()) {
        this.modalActive = true;
        this.modalImage = file.getImageUrl();
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
.ui-files {
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  .image {
    width: 130px;
    min-height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 3px;
    background-color: rgba(0, 0, 0, 0.1);
    img {
      border-radius: 3px;
    }
  }
}
</style>
